export const header = () => {
  const mediaQuery = window.matchMedia("(max-width: 1100px)");
  const header = document.getElementById("header");
  const dayNightContainer = document.getElementById("dayNightContainer");
  const viewSwitchContainer = document.querySelector(".view-switch-container");

  const offset = 0; // Adjust this value as needed for the container offset

  const handleScroll = () => {
    const containerTop = dayNightContainer.getBoundingClientRect().top;

    // Check if the dayNightContainer is in the view
    if (containerTop <= offset) {
      // Add class to header
      header.classList.add("scrolled-past-program");

      // Toggle view-switch-container to fixed when in view
      viewSwitchContainer.style.position = "fixed";
      viewSwitchContainer.style.top = "0"; // Ensure it's positioned at the top
    } else {
      // Remove class from header
      header.classList.remove("scrolled-past-program");

      // Toggle view-switch-container to absolute when not in view
      viewSwitchContainer.style.position = "absolute";
      viewSwitchContainer.style.top = "auto"; // Reset top positioning
    }
  };

  const toggleScrollListener = (event) => {
    if (event.matches) {
      document.addEventListener("scroll", handleScroll);
    } else {
      document.removeEventListener("scroll", handleScroll);
      header.classList.remove("scrolled");
    }
  };

  // Initial setup
  toggleScrollListener(mediaQuery);

  // Listen for media query changes
  mediaQuery.addEventListener("change", toggleScrollListener);

  // Cleanup if needed (optional return function for a framework)
};
